/**
 * SegmentDrawingPanel - Instructions and controls for drawing segments
 *
 * Shows context-sensitive instructions for drawing roof or free-field segments.
 */

import React from 'react';

interface SegmentDrawingPanelProps {
  isDrawing: boolean;
  isFreeFieldMode: boolean;
  vertexCount: number;
  onStartDrawing: () => void;
  onCancelDrawing: () => void;
}

export function SegmentDrawingPanel({
  isDrawing,
  isFreeFieldMode,
  vertexCount,
  onStartDrawing,
  onCancelDrawing,
}: SegmentDrawingPanelProps) {
  if (isDrawing) {
    return (
      <div className="space-y-2">
        <div className="text-xs text-gray-600 bg-blue-50 border border-blue-300 rounded p-2">
          {isFreeFieldMode ? (
            <>
              <p className="font-semibold mb-1">Drawing Free-Field Polygon:</p>
              <p>• Click to add vertices</p>
              <p>• Double-click or Enter to finish</p>
              <p>• Hold Shift for orthogonal edges</p>
              <p>• ESC to cancel</p>
              <p>• Hold <span className="font-semibold">Space</span> to pan map</p>
              {vertexCount > 0 && (
                <p className="mt-1 text-green-600">Vertices: {vertexCount}</p>
              )}
            </>
          ) : (
            <>
              <p className="font-semibold mb-1">Drawing Module Segment:</p>
              <p>• Click and drag to define fill zone</p>
              <p>• Segment auto-fills with modules</p>
              <p>• Hold <span className="font-semibold">Space</span> to pan map</p>
            </>
          )}
        </div>
        <button
          onClick={onCancelDrawing}
          className="w-full py-2 px-4 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors text-xs font-semibold"
        >
          Cancel Drawing
        </button>
      </div>
    );
  }

  return (
    <button
      onClick={onStartDrawing}
      className="w-full py-2 px-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-xs font-semibold"
    >
      + Draw Module Segment
    </button>
  );
}

export default SegmentDrawingPanel;
